// extracted by mini-css-extract-plugin
var _1 = "EmailTemplateSelectDropdownListItem-moduleEmailTemplateSelectDropdownListItem__XozI0 SelectDropdownListItem-moduleSelectDropdownListItem__EYKeu";
var _2 = "EmailTemplateSelectDropdownListItem-moduleicon__qlD7y SelectEntityItemAvatar-moduleavatar__zeGPU";
export { _1 as "EmailTemplateSelectDropdownListItem", _2 as "icon" }
